export const slidesData = [
    // {
    //   id: "001",
    //   img: "/images/ali-karimiboroujeni-U9B7dvn-qeI-unsplash.jpg",
    //   title: "Finde Premium Products",
    //   cta: "SHOP NOW",
    // },
      {
      id: "001",
      img: "/Images/landingpage_football_action_sec.png",
     title4: "Clothes reflect you",
     title1: "and We care for that reflection",
      cta: "SHOP NOW",
      },
    
    {
      id: "002",
      img: "/Images/dramatic_morning_light.png",
      title: "Try India’s Fastest",
      title4: "50% OFF GET UP TO ORDER",
      title1: "Premium Laundry Today",
      cta: "SHOP NOW",
    },
    {
      id: "003",
      img: "/Images/landing-cricket.png",
      title4: "Think Laundry ",
      title1: "Think LILI Care",
      cta: "SHOP NOW",
    },
  ];